<div class="form-container mt-2 p-3 card" >
  <header class="sub-header mb-2 p-1">
    <h5>Navigation</h5>
  </header>
  <form [formGroup]="form" (ngSubmit)="onUserSubmit(form.value)" class="user-form mt-3">
    <div class="row">
  
      <!-- Title -->
      <div class="col-md-6 col-lg-6 col-sm-12 col-12 mt-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Title</mat-label>
          <input matInput formControlName="title" (input)="preventEmpty()" [(ngModel)]="common.title" required />
          <mat-error *ngIf="form.get('title')?.hasError('required')">
            Title is required.
          </mat-error>
          <mat-error *ngIf="form.get('title')?.hasError('pattern')">
            Title must not start or contain only spaces.
          </mat-error>
        </mat-form-field>
      </div>
  
      <!-- Link Text -->
      <div class="col-md-6 col-lg-6 col-sm-12 col-12 mt-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Link Text</mat-label>
          <input matInput formControlName="linkText" (input)="preventEmpty()" [(ngModel)]="common.linkText" />
          <mat-error *ngIf="!form.get('linkText')?.valid">
            Enter valid link text
          </mat-error>
        </mat-form-field>

      </div>
  
      <!-- Icon Class -->
      <div class="col-md-6 col-lg-6 col-sm-12 col-12 mt-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Icon Class</mat-label>
          <input matInput formControlName="iconClass"(input)="preventEmpty()" [(ngModel)]="common.iconClass" required />
          <mat-error *ngIf="form.get('iconClass')?.hasError('required')">
            Icon Class is required.
          </mat-error>
        </mat-form-field>
      </div>
  
      <!-- Parent Name -->
      <div class="col-md-6 col-lg-6 col-sm-12 col-12 mt-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Parent Name</mat-label>
          <mat-select placeholder="Parent Name"
                      [(ngModel)]="common.navLinkParentId"
                      formControlName="navLinkParentId"
                      name="Parent">
            <mat-select-search autocomplete="off" [formControl]="ParentListCtrl"></mat-select-search>
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let mile of parentflt" [value]="mile.navLinkId">
              {{mile.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  
  
  </form>
  
  <div class="button-container">
    <button type="submit" class="btn btn-save btn-icon-text mb-2 mb-md-0 me-2" type="submit"
      (click)="onUserSubmit(form.value)" [disabled]="!form.valid || error" [ngClass]="{'btn-save': form.valid,'btn-disabled': !form.valid || error}">
      <mat-icon>save</mat-icon> <span *ngIf="!common.navLinkId">Save</span><span *ngIf="common.navLinkId">
        Update</span>
    </button>
    <button class=" btn btn-cancel btn-icon-text mb-2 mb-md-0" (click)="closeDialog()">
      <mat-icon>cancel</mat-icon> Cancel
    </button>
  </div>
</div>